import { render, staticRenderFns } from "./general-report.vue?vue&type=template&id=2c14a8c8&"
import script from "./general-report.vue?vue&type=script&lang=js&"
export * from "./general-report.vue?vue&type=script&lang=js&"
import style0 from "./general-report.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "general-report.vue"
export default component.exports